var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconProfile = function SvgIconProfile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#5047ff",
    d: "M9.366 12.001a4.8 4.8 0 1 0-4.766-4.8 4.8 4.8 0 0 0 4.766 4.8m1.934 1.8H7.5a6.5 6.5 0 0 0-6.5 6.5 1.3 1.3 0 0 0 1.3 1.3h10.74a1.5 1.5 0 0 1-.011-.639l.535-2.678a1.87 1.87 0 0 1 .513-.958l1.714-1.715a6.47 6.47 0 0 0-4.491-1.81m3.626 4.373a.68.68 0 0 0-.185.345l-.534 2.682a.338.338 0 0 0 .4.4l2.678-.536a.68.68 0 0 0 .345-.185l4.7-4.7-2.7-2.7Zm9.679-6.184-.79-.789a1.35 1.35 0 0 0-1.909 0l-1.43 1.43 2.7 2.7 1.43-1.43a1.354 1.354 0 0 0 0-1.911Z",
    "data-name": "Group 1787"
  })));
};
export default SvgIconProfile;